interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    // F1.5 — border-primary already maps to hi-vis after F1.2 primary remap
    <div
      className={`animate-spin rounded-full border-4 border-primary-500 border-t-transparent ${sizes[size]} ${className}`}
    />
  );
}

export function PageLoader() {
  return (
    <div className="surface-muted flex min-h-[220px] flex-col items-center justify-center gap-3">
      <Spinner />
      <p className="text-sm font-medium" style={{ color: 'var(--muted)' }}>Ładowanie danych</p>
    </div>
  );
}
